import React, { FC, FocusEventHandler, MouseEvent } from 'react';
import classNames from 'classnames';

import { Icon, IconProps } from '../Icon';

import styles from './Input.module.scss';

type MouseEventHandler = (event: MouseEvent) => void;

export interface IconButtonProps extends Pick<IconProps, ('icon' | 'size')> {
  onClick?: MouseEventHandler;
  onMouseDown?: MouseEventHandler;
  onMouseUp?: MouseEventHandler;
  onBlur?: FocusEventHandler;
  onFocus?: FocusEventHandler;
  name?: string;
  disabled?: boolean;
  className?: string;
}

const IconButton: FC<IconButtonProps> = ({
  icon,
  size,
  name,
  onClick,
  onMouseDown,
  onMouseUp,
  onBlur,
  onFocus,
  disabled = false,
  className,
}) => {
  const hasEvents = onClick || onMouseDown || onMouseUp;

  if (!hasEvents) {
    return (
      <Icon icon={icon}
            size={size}
            className={classNames(
              styles.iconButton,
              styles.iconButtonNoPointers,
              className,
            )} />
    );
  }

  return (
    <button name={name}
            className={classNames(
              styles.iconButton,
              className,
            )}
            onClick={onClick}
            onMouseDown={onMouseDown}
            onMouseUp={onMouseUp}
            onBlur={onBlur}
            onFocus={onFocus}
            type="button"
            disabled={disabled}>
      <Icon icon={icon}
            size={size} />
    </button>
  );
};

export default IconButton;
